<template>
  <div class="animated fadeIn">
    <div class="row pageinfo">
      <b-col lg="6">
        <!--Display Trash or Normal Table View-->
        <h2 v-show="!trash">{{ $options.name }}s</h2>
        <h2 v-show="trash">{{ $options.name }}s - Trash</h2>
      </b-col>
    </div>

    <div class="card">
      <div class="card-body">
        <b-row>
          <b-container fluid terminal>
            <!-- Main table element -->
            <b-row class="justify-content-between">
              <b-col md="4" class="my-1">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <b-form-input v-model="filter" placeholder="Search" />
                    <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                  </div>
                </div>
              </b-col>
              <b-col lg="3" class="my-1">
								<b-dropdown class="pull-left" :text="dpdt">
									<b-dropdown-item @click="trashTdg()">Active</b-dropdown-item>
									<b-dropdown-item @click="trashTdg()">Trash</b-dropdown-item>
								</b-dropdown>
							</b-col>
              <b-col lg="5" class="my-1">
                <b-button variant="primary" class="pull-right" @click="newTdgModal">Add {{ $options.name }}

                </b-button>
              </b-col>
            </b-row>
            <b-row v-if="loadingData">
              <b-col cols="12" sm="12" md="12" lg="12">
                <p class="text-center">
                  <i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br>Loading data...
                </p>
              </b-col>
            </b-row>
            <!-- End Main table Elements-->
            <b-table v-else striped hover bordered show-empty stacked="md" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" @filtered="onFiltered"  @row-clicked="rowClicked">

            </b-table>
            <b-row>
              <b-col lg="2" md="2" sm="12" class="my-1 pull-right">
                <div class="input-group mb-3">
                  <div class="input-group-prepend"></div>
                  <b-select :options="pageOptions" v-model="perPage" />
                </div>
              </b-col>
              <!-- User Interface controls -->

              <b-col lg="10" md="10" sm="12" class="my-1">
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0 pull-right" />
              </b-col>
            </b-row>
            <!-- End User Interface controls-->
          </b-container>
        </b-row>
      </div>
    </div>
    <!-- New Tdg Modal-->
    <b-modal title="New Tdg" size="lg" v-model="newTdg" ok-only ok-title="Cancel" ok-variant="secundary">
      <b-row>
        <b-col cols="12">
            <b-form-group :label-cols="4" id="L1" label="Common Name" label-for="Tdg1" horizontal>
              <b-form-input id="Tdg1" type="text" v-model="model.common_name"></b-form-input>
            </b-form-group>

            <b-form-group :label-cols="4" id="L2" label="Product Description" label-for="Tdg2" horizontal>
              <b-form-input id="Tdg2" type="text" v-model="model.product_description"></b-form-input>
            </b-form-group>

            <b-form-group :label-cols="4" id="L3" label="Packing Group" label-for="Tdg3" horizontal>
              <b-form-input id="Tdg3" type="text" v-model="model.packing_group"></b-form-input>
            </b-form-group>

            <b-form-group :label-cols="4" id="L4" label="Class" label-for="Tdg4" horizontal>
              <b-form-input id="Tdg4" type="text" placeholder="only numbers" v-mask="'##########'" v-model="model.class_tdg"></b-form-input>
            </b-form-group>

            <b-form-group :label-cols="4" id="L5" label="Shipping Name" label-for="Tdg5" horizontal>
              <b-form-input id="Tdg5" type="text" v-model="model.shipping_name"></b-form-input>
            </b-form-group>

            <b-form-group :label-cols="4" id="L6" label="Un" label-for="Tdg6" horizontal>
              <b-form-input id="Tdg6" type="text" placeholder="only numbers" v-mask="'##########'" v-model="model.un"></b-form-input>
            </b-form-group>

            <b-form-group v-if="fluidtypeselect.length > 0" :label-cols="4" id="L7" label="Fluid Types" label-for="Tdg7" horizontal>
                <b-form-checkbox-group value-field="id" text-field="name"  class="custom-checkboxes" :options="fluidtypeselect" name="Checkboxes2" plain v-model="model.fluid_types_id" @input="fluidtypesChange()"></b-form-checkbox-group>
                <b-form-checkbox style="margin-top: 15px;" v-model="ftAllSelected" :indeterminate="indeterminateFT" aria-describedby="" aria-controls="" plain @change="FTToggleAll">
                    {{ ftAllSelected ? 'Un-select All' : 'Select All' }}
                </b-form-checkbox>
            </b-form-group>
            <p v-else>No fluid type registered</p>
        </b-col>  
      </b-row>
      <div slot="modal-footer" class="w-100">
        <b-btn size="md" variant="secondary" @click="newTdg=false" class="float-left">Cancel</b-btn>
        <b-btn :disabled="savebtn" size="md" variant="primary" @click="saveTdg" class="float-right">Save</b-btn>
      </div>
    </b-modal>
    <!-- End New Tdg Modal-->
    </div>
</template>

<script>
  import Vue from 'vue'
  import cnr_service from './cnr_service'

  const items = []
  export default {
    name: 'TDG',
    created: function() {
      this.getAll()
    },
    data() {
      return {
        trash       : false,
        dpdt        : 'Active',
        model       : {
                        common_name         : '',
                        product_description : '',
                        packing_group       : '',
                        class_tdg           : null,
                        shipping_name       : '',
                        un                  : null,
                        fluid_types_id      : [],
                    },
        newTdg   : false,
        items       : items,
        fields:     [
                        {
                            key: 'id',
                            label: 'ID',
                            sortable: true
                        },
                        {
                            key: 'common_name',
                            label: 'Common Name',
                            sortable: true
                        },
                        {
                            key: 'product_description',
                            label: 'Product Description',
                            sortable: false
                        },
                        {
                            key: 'packing_group',
                            label: 'Packing Group',
                            sortable: false
                        },
                        {
                            key: 'class_tdg',
                            label: 'Class',
                            sortable: false
                        },
                        {
                            key: 'shipping_name',
                            label: 'Shipping Name',
                            sortable: false
                        },
                        {
                            key: 'un',
                            label: 'Un',
                            sortable: false
                        },
                    ],
        currentPage : 1,
        perPage     : 25,
        totalRows   : items.length,
        pageOptions : [25, 50, 100],
        sortBy      : 'id',
        sortDesc    : false,
        filter      : null,
        loadingData : true,
        savebtn     :true,
        fluidtypeselect				: [],
		indeterminateFT				: false,
		ftAllSelected				: false,
      }
    },
    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return {
              text: f.label,
              value: f.key
            }
          })
      }
    },
    methods: {
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        newTdgModal() {
            this.model = {
                common_name         : '',
                product_description : '',
                packing_group       : '',
                class_tdg           : null,
                shipping_name       : '',
                un                  : null,
                fluid_types_id      : [],
            }
            this.savebtn=false
            this.newTdg = true
        },
        trashTdg() {
                    this.trash = !this.trash
                    this.dpdt = this.trash ? "Trash" : "Active"
                    this.getAll()
                    this.loadingData = true
                },
        rowClicked(row) {
                    if(!this.trash) {
                        this.$router.push('/tdg/' + row.id + '/')
                    } else {
                        this.restoreTdg(row.id)
                    }
        },
        okToSave() {
            if (this.model.common_name === undefined || this.model.common_name.trim().length == 0) {
                this.$swal('Alert!', 'Common Name can not be empty', 'warning')
                return false
            }
            if (this.model.product_description === undefined || this.model.product_description.trim().length == 0) {
                this.$swal('Alert!', 'Product Description can not be empty', 'warning')
                return false
            }
            if (this.model.packing_group === undefined || this.model.packing_group.trim().length == 0) {
                this.$swal('Alert!', 'Packing Group can not be empty', 'warning')
                return false
            }
            if (this.model.class_tdg === null || this.model.class_tdg.trim().length == 0) {
                this.$swal('Alert!', 'Class can not be empty', 'warning')
                return false
            }
            if (this.model.shipping_name  === undefined || this.model.shipping_name.trim().length == 0) {
                this.$swal('Alert!', 'Shipping Name can not be empty', 'warning')
                return false
            }
            if (this.model.un === null || this.model.un.trim().length == 0) {
                this.$swal('Alert!', 'Un can not be empty', 'warning')
                return false
            }
            return true
	    },
        saveTdg () {
            if (!this.okToSave()) {
                    return
            }
            console.log(this.model)
            cnr_service.save_tdg(this.model)
            .then(data => {
                this.$swal(data.status, data.message, data.status)
                .then((result) => {
                    if (data.status == 'success') {
                    this.newTdg = false
                    this.getAll()
                    }
                })
            })
            .catch(error => {
                this.$swal('Error', 'Server not response. ' + error, 'error')
            })
            this.savebtn=false
        },
        getAll() {
            this.loadingData = true
            cnr_service.getAll_tdg()
            .then(data => {
                if (data.status == 'success') {
                    this.items = data.tdgs.filter(o => o.status_id == (this.trash ? 2 : 1))
                    this.fluidtypeselect  				= data.fluid_types
                }else {
                    this.$swal(data.status, data.message, data.status)
                    this.fluidtypeselect  				= []
                    this.loadingData = false
                return
                }
                this.loadingData = false
            })
            .catch(error => {
                Vue.swal('Error', 'Server not response. ' + error, 'error')
                this.loadingData = false
            })
        },
        restoreTdg(id) {
                this.$swal({
                        title: 'Please, confirm',
                        text: "Are you sure to restore this Tdg ?",
                        type: 'question',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes',
                        reverseButtons: true
                    }).then((result) => {
                        if (result.value) {
                            cnr_service.restore_tdg(id)
                                .then(data => {
                                    this.$swal(data.status, data.message, data.status)
                                    if (data.status == 'success') {
                                        this.filter = ''
                                        this.trash = false
                                        this.getAll()
                                        this.loadingData = true
                                    }
                                })
                                .catch(error => {
                                    this.$swal('Error', 'Server not response. ' + error, 'error')
                                })
                        }
                    })
        },
        FTToggleAll(checked) {
            this.model.fluid_types_id = checked ? this.fluidtypeselect.map(item => {
                return item.id
            }) : []
        },
        fluidtypesChange() {
            if (this.model.fluid_types_id.length === 0) {
                this.indeterminateFT = false
                this.ftAllSelected = false
            } else if (this.model.fluid_types_id.length === this.fluidtypeselect.length) {
                this.indeterminateFT = false
                this.ftAllSelected = true
            } else {
                this.indeterminateFT = true
                this.ftAllSelected = false
            }
        },

    }
  }
</script>


// WEBPACK FOOTER //
// src/views/cnr/tdgs.vue